import { useEffect } from 'react';
import './FourOhFour.css';
import SEOHead from '../../components/SEOHead';
import { SEO_CONFIG, getCanonicalUrl } from '../../config/seo';

function FourOhFour() {
  useEffect(() => {
    document.title = '404 | Phoenix Unity Designs';
  }, []);

  return (
    <>
      <SEOHead
        title={SEO_CONFIG.notFound.title}
        description={SEO_CONFIG.notFound.description}
        keywords={SEO_CONFIG.notFound.keywords}
        canonical={getCanonicalUrl(SEO_CONFIG.notFound.path)}
      />
      <main id="main-content" tabIndex="-1" className='FourOhFour page-container'>
      <div className='container mb-5'>
        <div className='row'>
          <div className='col'>
            <h1>404</h1>
            <p className='tagline'>Page not found</p>
            <p>It appears the page you are looking for does not exist. 😬</p>
          </div>
        </div>
      </div>
    </main>
    </>
  );
}

export default FourOhFour;
